function About() {
  return (
    <>
      <h1 className='text-6xl mb-4'>Github Finder</h1>
      <p className='mb-4 text-2xl font-light'>
        A React app to search GitHub profiles and see profile details. This
        project is part of my project made as part of the
        <a href='https://www.udemy.com/course/modern-react-front-to-back/'>
          {' '}
          React Front To Back
        </a>{' '}
        Udemy course. Built by 
        <strong>
          <a href='https://www.linkedin.com/in/aanchal-chaurasia-201200191/'> Aanchal Chaurasia </a>
        </strong>
        .
      </p>
    </>
  )
}

export default About
